import Components from './components';
import RelevancyMosaic from './RelevancyMosaic';
import { RelevancyOptionsProvider } from './store';

export const App = ({ options }) => (
  <RelevancyOptionsProvider
    options={{
      ...options,
      Components,
    }}
  >
    <RelevancyMosaic />
  </RelevancyOptionsProvider>
);

export default App;
